// import moment from "moment";
import _ from "lodash";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import slugify from "slugify";
import { config } from "../config/app";
import { RouterName } from "../router";
import store from "../store/store";
import { deviceStorage } from "./devicestorage";

import { categories } from "./category";

import uuid from "react-uuid";
import { _t } from "core/language";

export const numberFormat = (number: number | string, thousandDigit: string = ',', fixed: number = 2): string => {
    // Kiểm tra xem đầu vào có phải là số hay không
    const num: number = typeof number === 'string' ? parseFloat(number) : number;
    if (isNaN(num)) {
        return "Invalid number input";
    }

    // Kiểm tra số âm để xử lý định dạng
    const isNegative: boolean = num < 0;
    const absNum: number = Math.abs(num);

    // Chia thành phần nguyên và thập phân
    const intPart: number = Math.floor(absNum);
    let decimalPart: string = (absNum - intPart).toFixed(fixed).slice(2); // Loại bỏ số 0 trước dấu chấm
    decimalPart = decimalPart?.replace(/(\.0+|0+)$/, '') // loại bỏ số 0 ở cuối

    // Xác định dấu phân cách hàng nghìn và dấu thập phân
    const decimalSeparator: string = thousandDigit === '.' ? ',' : '.';

    // Định dạng phần nguyên với ký tự phân biệt hàng nghìn
    // console.log(49, intPart)
    let locale = "en-US"
    switch(appLoc()){
        case "VN": locale = 'vi-VN'; break;
    }
    let formattedIntPart: string = intPart.toLocaleString(`${locale}`);//.replace(/,/g, separator);
    // console.log(51, formattedIntPart)
    // Xử lý trường hợp dấu phân cách hàng nghìn nằm ở cuối số hàng đơn vị

    if (formattedIntPart.endsWith(thousandDigit)) {
        formattedIntPart = formattedIntPart.slice(0, -1);
    }

    // Kết hợp các phần đã định dạng và xử lý số âm
    let formattedNumber: string
    if(absNum - intPart > 0) formattedNumber = `${formattedIntPart}${decimalSeparator}${decimalPart}`;
    else formattedNumber =  `${formattedIntPart}`
    if (isNegative) {
        formattedNumber = `-${formattedNumber}`;
    }

    return formattedNumber;
}

export const appLoc = (): string => {
    return deviceStorage[config.appStorage].getItem(config.appPackage+'_APP-LOC') || 'VN'

}

export const appLang = () => {
    return (window as any)._APP_LANG
}

export const getCountryCode = (data: any) => {
    const code: any = []
    data.map((item: any) => {
        code.push(item.country_phone_code)
    })
    return code
}

export const localeNumberFormat = (number: number|string, locale: string) => {
    switch (locale) {
        case "VN": return numberFormat(number, '.', 2)
        default: return numberFormat(number, ',', 2)
    }
}

export const localeCategory = (id: number, locale: string) => {
    try {
        if (!['vi', 'ko', 'en'].includes(locale.toLowerCase())) locale = 'en'
        // console.log(categories)
        const [cat]: any = _.filter(categories, (item: any) => item.id == id);
        // console.log(91, cat)
        if (cat) {
            const [trans]: any = _.filter(cat.translations, (item: any) => item.language.code.toLowerCase() == locale.toLowerCase())
            // console.log(94, trans)
            if (trans) return trans.name
        }
        return '';
    } catch (e: any) {
        console.log(98, e);
        
        return '';
    }
}

export const mapLanguage = (data: any, locale: string) => {
    try {
        if(data.length > 0) {
            let nameMap = ''
            const filterData = data.filter((item:any) => item?.language?.code == locale);
            if(filterData.length > 0) {
                nameMap = filterData[0].name
                return nameMap
            }
        }
        return '';
    } catch (e: any) {
        console.log(98, e);
        
        return '';
    }
}

export const mapListCategoryByLang = (data: any, locale: string) => {
    try {
        const localeMap = locale ? locale.toLowerCase() : 'vi'
        if(data.length > 0) {
            data.map((item: any) => (
                item.name = mapLanguage(item.translations,localeMap)
            ))
        }
        return data
    } catch (e: any) {
        console.log(98, e);
        
        return '';
    }
}

export const localeNumberParse = (value: string, locale: string) => {
    let standardValue: any
    switch (locale) {
        case "VN":
            standardValue = value
            standardValue = standardValue.replace(/,/g, '_');
            // console.log(92, standardValue)
            standardValue = standardValue.replace(/\./g, '')
            // console.log(94, standardValue)
            standardValue = standardValue.replace(/_/g, '.')
            break;
        default:
            standardValue = value
            standardValue = standardValue.replace(/,/g, '')
            break
    }
    return standardValue ? parseFloat(standardValue) : ""
}

export const appCurencyUnit = () => {
    const redux = store.getState();
    return redux?.AppSettings?.data?.locale?.currency_name || ''
}

export const documentTitle = (str: string) => {
    document.title = str;
}

export const convertToSlug = (text: string) => {
    return slugify(text, {
        replacement: "-", // Sử dụng dấu gạch ngang thay thế khoảng trắng và các ký tự đặc biệt
        remove: /[*+~.()'"!:@]/g, // Loại bỏ các ký tự đặc biệt
        lower: true, // Chuyển đổi thành chữ thường
    });
}


export function phoneNumberFormatOld(phone: string, encode: boolean = false) {
    let phoneFormat = phone;
    if (typeof phoneFormat == 'string') {
        phoneFormat.replaceAll('', '-')
        const phoneArray = phone.split("");
        if (phone.length > 11) {
            return ''
        }
        if (phone.length >= 8 && phone.length <= 11) {
            phoneArray.map((item: string, index: number) => {
                if (index === 2 || index === 6) {
                    phoneArray[index] = item + '-'
                }
            })

            phoneFormat = phoneArray.join('');
        } else if (phone.length >= 4) {
            phoneArray.map((item: string, index: number) => {
                if (index === 2) {
                    phoneArray[index] = item + '-'
                }
            })
            phoneFormat = phoneArray.join('');
        }
        if (encode) {
            const phoneArr = phoneFormat.split('-');
            const hiddenPart = '**';
            const visiblePart = phoneArr[1].substr(0, phoneArr[1].length - 2);
            return phoneArr[0] + '-' + visiblePart + hiddenPart + '-' + phoneArr[2];
        }
        return phoneFormat;
    }
    return ''
}

export const minMaxValidate = (value: number, min: number, max: number) => {
    if (value >= min && value <= max) {
        return true;
    }
    return false;
}

export const stringLimit = (string: string | undefined, limit: number = 30) => {
    if (string != undefined && string.length > limit) {
        return `${string.substring(0, limit)}...`
    } else {
        return string
    }
}

export const validateNumber = (data: any) => {
    const valueNumber = data;
    const re = /^[0-9\b]+$/;
    let value = false
    if (valueNumber === '' || re.test(valueNumber)) {
        value = valueNumber
    }
    return value
}


export function removeAllStorage() {
    sessionStorage.clear();
    deviceStorage[localStorage.getItem("storage_driver") || "session"].removeItem('persist:root')
    deviceStorage[localStorage.getItem("storage_driver") || "session"].removeItem(config.appPackage + '_X_TOKEN')
    deviceStorage[localStorage.getItem("storage_driver") || "session"].removeItem('remember_me')
}

export const s3Image = (path: string) => {
    return config.s3Url + '/' + path
}

export const validatePassword = (data: any) => {
    const valueNumber = data;
    const re = /^[A-Za-z0-9_.]+$/;
    let value = false
    if (valueNumber === '' || re.test(valueNumber)) {
        value = valueNumber
    }
    return value
}


export const hideBottomButtonInputFocus = (bottomClass = '.bottom-btn', durationLoad = 500) => {
    const windowHeight = window.innerHeight

    const handleWindowResize = () => {
        const btnBottomElements = document.querySelectorAll(bottomClass);

        // Kiểm tra kích thước cửa sổ và ẩn/hiện các phần tử tùy thuộc vào điều kiện của bạn.
        // alert(window.innerHeight + " --- "+ windowHeight)
        // // //console.log(115, windowHeight > window.innerHeight)
        if (windowHeight > window.innerHeight) {
            // // //console.log(116, windowHeight, window.innerHeight)
            btnBottomElements.forEach((element: any) => {
                element.style.display = 'none';
            });
        } else {
            // // //console.log(120, windowHeight, window.innerHeight)
            btnBottomElements.forEach((element: any) => {
                element.style.display = 'block';
            });
        }
    };

    // Đăng ký sự kiện resize của cửa sổ và gọi hàm xử lý khi kích thước thay đổi.
    window.addEventListener('resize', handleWindowResize);

    // Gọi hàm xử lý lần đầu để ẩn/hiện phần tử dựa trên kích thước ban đầu của cửa sổ.
    handleWindowResize();

    // Check riêng cho trường hợp trên IOS. Trên IOS sự kiện resize không hoạt động vì keyboard đang được fixed lên màn hình
    if (detectPlatformIos()) {
        setTimeout(() => {
            const inputElements = document.querySelectorAll('input');
            inputElements.forEach((element: any) => {
                element.addEventListener('focus', function () {
                    document.querySelectorAll(bottomClass).forEach(function (elementBtn: any) {
                        elementBtn.style.opacity = '0';
                    });
                });
                element.addEventListener('blur', function () {
                    document.querySelectorAll(bottomClass).forEach(function (elementBtn: any) {
                        elementBtn.style.opacity = '1';
                    });
                });
            });
        }, durationLoad);
    }

}

export const useCustomNavigate = () => {
    const navigate = useNavigate();

    const handleNavigation = (path: string, option: any = {}) => {
        let _path = path
        if(path === '/') {
            _path = RouterName.MAIN
        }
        navigate(_path, option);
    };

    return handleNavigation;
};

export const useBackNavigate = () => {
    const navigate = useNavigate();

    const handleNavigation = (path: string|undefined = undefined, option: any = {}) => {
        if(path) navigate(path, option);
        else {
            navigate(-1)
        }
    };

    return handleNavigation;
};

export const getTimeZoneName = (localeTimeZone: string) => {
    switch (localeTimeZone){
        case "VN": return "Asia/Ho_Chi_Minh";
        case "KR": return "Asia/Seoul";
        default: return "Asia/Ho_Chi_Minh"
    }
}

export function formatDateTime(dateTime: any, format = 'YYYY-MM-DD HH:mm:ss') {
    if (!dateTime) return null;
    return moment.tz(dateTime, 'Etc/UTC').tz(getTimeZoneName(appLoc())).format(format)
}

export function formatDate(dateTime: any, format = 'YYYY-MM-DD') {
    if (!dateTime) return null;
    return moment.tz(dateTime, 'Etc/UTC').tz(getTimeZoneName(appLoc())).format(format)
}

export const nowTimezone = (): any =>{
    return moment.tz(getTimeZoneName(appLoc()))
}



export const getLocalUrl = (path: any) => {
    const myloc = window.location.href;
    return myloc.substring(0, myloc.lastIndexOf('/')) + path;
}


export const getValidationErrors = (err: any) => {
    const validationErrors: any = {};

    err.inner.forEach((error: any) => {
        if (error.path) {
            validationErrors[error.path] = error.message;
        }
    });

    return validationErrors;
}

export const detectPlatformIos = () => {

    const userAgent = window.navigator.userAgent;
    // @ts-ignore
    const platform = window.navigator?.userAgentData?.platform || window.navigator.platform
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']
    let os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = false;
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = true;
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = false;
    } else if (/Android/.test(userAgent)) {
        os = false;
    } else if (/Linux/.test(platform)) {
        os = false;
    }

    return os;
}


export const priceFormat = (price: any, n = 0, x = 3, s = ',', c = '.') => {
    if (price) {
        price = +price
        const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')'
        const num = price.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    }
    return 0
}


export function phoneNumberFormat (str:string, encode: boolean=false) {
    let valueFormat = str;
    if(str && typeof str == 'string') {
        const cleanedInput = str.replace(/[^0-9]/g, '');
        // if(cleanedInput.length > 11) {
        //     return ''
        // }
        //Neu dau so 02
        if(cleanedInput.slice(0, 2) == '02'){
            // Kiểm tra độ dài của chuỗi đã làm sạch
            if (cleanedInput.length <= 2) {
                // Nếu chuỗi có 2 ký tự hoặc ít hơn, không cần định dạng
                valueFormat = cleanedInput;
            } else if (cleanedInput.length <= 5) {
                // Nếu chuỗi có từ 2 đến 5 ký tự, định dạng là "xx-xxx"
                valueFormat = cleanedInput.slice(0, 2) + '-' + cleanedInput.slice(2);
            }else if (cleanedInput.length <= 9) {
                // Nếu chuỗi có từ 5 đến 9 ký tự, định dạng là "xx-xxx-xxx"
                valueFormat = (
                    cleanedInput.slice(0, 2) +
                    '-' +
                    cleanedInput.slice(2, 5) +
                    '-' +
                    cleanedInput.slice(5, 10)
                );
            } else {
                // Nếu chuỗi có từ 8 ký tự trở lên, định dạng là "xxx-xxxx-xxxx"
                valueFormat = (
                    cleanedInput.slice(0, 2) +
                    '-' +
                    cleanedInput.slice(2, 6) +
                    '-' +
                    cleanedInput.slice(6, 10)
                );
            }
        } else if(cleanedInput.slice(0, 3) != '010'){

            // Kiểm tra độ dài của chuỗi đã làm sạch
            if (cleanedInput.length <= 3) {
                // Nếu chuỗi có 3 ký tự hoặc ít hơn, không cần định dạng
                valueFormat = cleanedInput
            } else if (cleanedInput.length <= 6) {
                // Nếu chuỗi có từ 4 đến 6 ký tự, định dạng là "xxx-xxx"
                valueFormat = cleanedInput.slice(0, 3) + '-' + cleanedInput.slice(3);
            } else if (cleanedInput.length <= 10) {
                // Nếu chuỗi có từ 4 đến 7 ký tự, định dạng là "xxx-xxx"
                valueFormat = (
                    cleanedInput.slice(0, 3) +
                    '-' +
                    cleanedInput.slice(3, 6) +
                    '-' +
                    cleanedInput.slice(6, 10)
                );
            } else {
                // Nếu chuỗi có từ 8 ký tự trở lên, định dạng là "xxx-xxxx-xxxx"
                valueFormat = (
                    cleanedInput.slice(0, 3) +
                    '-' +
                    cleanedInput.slice(3, 7) +
                    '-' +
                    cleanedInput.slice(7, 11)
                );
            }

        }else {
            
            // Kiểm tra độ dài của chuỗi đã làm sạch
            if (cleanedInput.length <= 3) {
                // Nếu chuỗi có 3 ký tự hoặc ít hơn, không cần định dạng
                valueFormat = cleanedInput;
            } else if (cleanedInput.length <= 7) {
                // Nếu chuỗi có từ 4 đến 7 ký tự, định dạng là "xxx-xxx"
                valueFormat = cleanedInput.slice(0, 3) + '-' + cleanedInput.slice(3);
            } else {
                valueFormat = (
                    cleanedInput.slice(0, 3) +
                    '-' +
                    cleanedInput.slice(3, 7) +
                    '-' +
                    cleanedInput.slice(7, 11)
                );
            }

        }
        if(encode) {
            const dataPhone = phoneNumberFormat(str);
            const phoneArr: any = dataPhone.split('-');
            const hiddenPart = '**';
            const visiblePart = phoneArr[1].substr(0, phoneArr[1].length - 2);
            return phoneArr[0] + '-' + visiblePart + hiddenPart + '-' + phoneArr[2];
        }
        return valueFormat
    }
    
    return ''
}

export const capitalizeFirstLetter = (word: string) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export function nl2br (str: string, replaceMode?: any, isXhtml?: any) {

  const breakTag = (isXhtml) ? '<br />' : '<br>';
  const replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
}


export const timeCountDown = (targetTime: any) => {

    const targetDate = new Date(targetTime);
    const currentDate = new Date();

    if (isNaN(targetDate.getTime())) {
        console.error('Invalid target time format. Please use the format: YYYY-MM-DD HH:mm:ss');
        return;
    }

    const countdown = targetDate.getTime() - currentDate.getTime();

    if (countdown <= 0) {
        //console.log('Countdown expired!');
        return;
    }

    const seconds = Math.floor(countdown / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    const remainingHours = hours % 24;
    const remainingMinutes = minutes % 60;
    const remainingSeconds = seconds % 60;

    const formattedCountdown = `${days} days, ${remainingHours} hours, ${remainingMinutes} minutes, ${remainingSeconds} seconds`;

    //console.log(`Countdown: ${formattedCountdown}`);
    return formattedCountdown
}

export function isKeyPressed(event: any, key: any, Constants: any) {
    // There are two types of keyboards
    // 1. English with different layouts(Ex: Dvorak)
    // 2. Different language keyboards(Ex: Russian)

    if (event.keyCode === Constants.KeyCodes.COMPOSING[1]) {
        return false;
    }

    // checks for event.key for older browsers and also for the case of different English layout keyboards.
    if (typeof event.key !== 'undefined' && event.key !== 'Unidentified' && event.key !== 'Dead') {
        const isPressedByCode = event.key === key[0] || event.key === key[0].toUpperCase();
        if (isPressedByCode) {
            return true;
        }
    }

    // used for different language keyboards to detect the position of keys
    return event.keyCode === key[1];
}
export const renderPath = (data: any) => {
    if (data?.url?.thumbnail) {
        // console.log(1118, data.url?.thumbnail)
        const src = data.url?.thumbnail.includes(config.s3Url)
        ? data.url?.thumbnail
        : config.s3Url+'/images/'+data.url?.thumbnail
        // console.log(1119, src)
        return src;
    }else{
        return data?.path
    }
}

export const renderFileUUId = (data: any) => {
    if (data?.uuid) {
        return data.uuid
    }else if(data?.file_uuid){
        return data?.file_uuid
    }else if(data?.id){
        return data?.id
    }else{
        return uuid().toString()
    }
    
}
export function getYouTubeThumbnail(
    videoId: string,
    quality: 'max' | 'standard' = 'standard'
): string {
    if (!videoId) {
        return ''
    }
    // Define base URL and thumbnail quality
    const baseUrl = `https://img.youtube.com/vi/${videoId}`;
    const thumbnailQuality = quality === 'max' ? 'maxresdefault' : 'hqdefault';
    // Construct and return the full thumbnail URL
    return `${baseUrl}/${thumbnailQuality}.jpg`;
}

export function removeVietnameseTones(str: string, removeSpace: boolean = true) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a"); 
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e"); 
  str = str.replace(/ì|í|ị|ỉ|ĩ/g,"i"); 
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o"); 
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u"); 
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y"); 
  str = str.replace(/đ/g,"d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  if (removeSpace) {
    str = str.replace(/ + /g," ");
    str = str.replace(/ /g,"");
    str = str.trim();
  }
  // Remove punctuations
  str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g," ");
  return str;
}

export function megerArrayList(arr1:[], arr2:[]){
    const arr1Ids = new Set(arr1.map((item:any) => item.id));

    const mergedArray = [
        ...arr1, 
        ...arr2.filter((item:any) => !arr1Ids.has(item.id))
    ];
    return mergedArray
}

export function removeItemByIdInArray(list:any, idRemove: number) {
    return list.filter((item:any) => item?.id !== idRemove);
}

export function getCodeLangById(id?:any, languages:any = []) {
    const code = (window as any)._APP_LANG
    if (!id || !Array.isArray(languages)) return code;
    const foundLang = languages.find((lang:any) => lang.id === id);
    return foundLang ? foundLang.code : code;
}

export const numberFormatCurrency = (number: number | string, thousandDigit: string = ',', fixed: number = 2): string => {
    // Kiểm tra xem đầu vào có phải là số hay không
    const num: number = typeof number === 'string' ? parseFloat(number) : number;
    if (isNaN(num)) {
        return "Invalid number input";
    }

    // Kiểm tra số âm để xử lý định dạng
    const isNegative: boolean = num < 0;
    const absNum: number = Math.abs(num);

    // Chia thành phần nguyên và thập phân
    const intPart: number = Math.floor(absNum);
    let decimalPart: string = (absNum - intPart).toFixed(fixed).slice(2);

    // Loại bỏ số 0 không cần thiết ở cuối phần thập phân
    if (fixed > 0) {
        decimalPart = decimalPart.replace(/0+$/, '');
        if (decimalPart === '') {
            decimalPart = '0';
        }
    }

    // Định dạng phần nguyên với ký tự phân biệt hàng nghìn
    const intPartString: string = intPart
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, thousandDigit);

    // Kết hợp các phần đã định dạng
    let formattedNumber: string = fixed > 0 && decimalPart !== '0'
        ? `${intPartString}${thousandDigit === ',' ? '.' : ','}${decimalPart}`
        : intPartString;

    // Xử lý số âm
    if (isNegative) {
        formattedNumber = `-${formattedNumber}`;
    }

    return formattedNumber;
};

export const shortenNumber = (num:any) => {
    if (num < 1000) return num.toString();
    if (num < 1000000) return Math.floor(num / 1000) + 'K';
    if (num < 1000000000) return Math.floor(num / 1000000) + 'M';
    return Math.floor(num / 1000000000) + 'B';
};

export const sortGalleryByType = <T extends { type: string }>(items: T[]) => {
  const images = items.filter((item) => item.type === 'image');
  const videos = items.filter((item) => item.type === 'video');

  return [...videos, ...images];
};

export const truncateString = (str:string, maxLength = 150) => {
    if (!str || str == null) return ""; 
    return str.length > maxLength ? str.slice(0, maxLength) + "..." : str;
};
export const handleMapShortContent = (dataItem?:any, maxLength?:number) => {
    const titlePost = dataItem?.content && dataItem?.content != null ? dataItem?.content : '';
    
    let shortContent = truncateString(titlePost, maxLength)
    if(!titlePost && dataItem?.shared_post){
        // shortContent = dataItem?.shared_post?.content 
        shortContent = `${_t("comunity.shared_post")}`
    }
    if(!titlePost && dataItem?.files && dataItem?.files.length > 0){
        shortContent = _t("comunity.detail.shared_community")
    }
    if(!titlePost && dataItem?.recipe){
        shortContent = `${_t("comunity.detail.shared")} < ${dataItem?.recipe?.name} >` 
    }
    return nl2br(shortContent);
};
